export enum CardBrandEnum {
  Amex = 'amex',
  Visa = 'visa',
  Mastercard = 'mastercard',
  GooglePay = 'google_pay',
  ApplePay = 'apple_pay',
}
